export default function (value: unknown): boolean {
  return !!value;
}
